import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { useId, useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { includedAdditionalUnitsSelector } from '../../../selectors/ContactsSelectors';
import PaidUsersModal from '../../common/quantityPacks/PaidUsersModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IncludedUsers = ({
  quantityPackSkuId,
  productLine,
  productLevel
}) => {
  const [paidUsersModalOpen, setPaidUsersModalOpen] = useState(false);
  const IncludedUsersTitleId = useId();
  const includedAdditionalUnits = useAppSelector(state => includedAdditionalUnitsSelector(state, {
    quantityPackSkuId
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      id: IncludedUsersTitleId,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "merchCardsV2.subtextDisplay.includesPaidUsers",
        options: {
          count: includedAdditionalUnits,
          includedPaidUsers: /*#__PURE__*/_jsx(Link, {
            onClick: () => setPaidUsersModalOpen(true),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "merchCardsV2.subtextDisplay.paidUsers"
            })
          })
        }
      })
    }), paidUsersModalOpen && /*#__PURE__*/_jsx(PaidUsersModal, {
      productLevel: productLevel,
      productLine: productLine,
      onCloseClick: () => setPaidUsersModalOpen(false)
    })]
  });
};